import React, { useState, useRef } from 'react';
import './style/ReviewModal.css';
import { useWallofLoveContext } from '../contexts/WallofLoveContext';
import ReCAPTCHA from 'react-google-recaptcha';
import { useTranslation } from 'react-i18next';

function ReviewModal({ onClose }) {
  const { submitReview } = useWallofLoveContext();

  const [name, setName] = useState('');
  const [rate, setRate] = useState(0);
  const [description, setDescription] = useState('');
  const [email, setEmail] = useState('');
  const [eventType, setEventType] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const recaptchaRef = useRef(null);
  const { t } = useTranslation();

  const eventTypes = [
    t('WallOfLovePage.Mariage'),
    t('WallOfLovePage.Anniversaire'),
    t('WallOfLovePage.Baptême'),
    t('WallOfLovePage.Soiree'),
    t('WallOfLovePage.babyShower'),
    t('WallOfLovePage.CorporateEvent'),
    t('WallOfLovePage.Other')
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name.trim() || !description.trim() || rate < 1 || rate > 5 || !eventType) {
      setErrorMessage(t('WallOfLovePage.RateError'));
      return;
    }

    setErrorMessage('');
    setLoading(true);

    try {
      let captchaToken = '';
      //console.log("🔑 Clé sitekey utilisée :", process.env.REACT_APP_RECAPTCHA_SITE_KEY);

      try {
        if (recaptchaRef.current && recaptchaRef.current.executeAsync) {
          //console.log("🔐 Tentative d’exécution de reCAPTCHA...");
          captchaToken = await recaptchaRef.current.executeAsync();
          //console.log("✅ Token reCAPTCHA obtenu :", captchaToken);
          recaptchaRef.current.reset();
        } else {
          console.warn("⚠️ recaptchaRef non disponible ou sans méthode executeAsync");
        }
      } catch (err) {
        console.error("❌ Erreur lors de executeAsync :", err);
        captchaToken = ''; // fallback vide ou fictif en dev
      }

      if (!captchaToken) {
        setErrorMessage(t('WallOfLovePage.CaptchaError'));
        setLoading(false);
        return;
}


      const now = new Date();
      const formattedDate = `${String(now.getDate()).padStart(2, '0')}-${String(now.getMonth() + 1).padStart(2, '0')}-${now.getFullYear()}`;

      const review = {
        Name: name,
        Rate: rate.toString(),
        Description: description,
        Email: email,
        Type: eventType,
        Date: formattedDate,
        captchaToken
      };

      await submitReview(review);
      setSuccessMessage(t('WallOfLovePage.SubmitSuccess'));
      setTimeout(() => {
        setSuccessMessage('');
        setLoading(false);
        onClose();
      }, 2500);
    } catch (err) {
      setErrorMessage(t('WallOfLovePage.SubmitionError'));
      //console.error('Erreur lors de la soumission :', err);
      setLoading(false);
    }
  };

  return (
    <div className="review-modal-overlay">
      <div className="review-modal">
        <div className="review-modal-header">
          <span>{t('WallOfLovePage.SendReview')}</span>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>
        <form onSubmit={handleSubmit}>
          <label>{t('WallOfLovePage.Name')}</label>
          <input
            type="text"
            value={name}
            onChange={(e) => {
              if (e.target.value.length <= 40) setName(e.target.value);
            }}
            placeholder= {t('WallOfLovePage.Max40caracteres')}
            required
          />

          <label>{t('WallOfLovePage.Rate')}</label>
          <div className="stars">
            {[1, 2, 3, 4, 5].map((i) => (
              <span
                key={i}
                onClick={() => setRate(i)}
                className={i <= rate ? 'filled' : ''}
              >★</span>
            ))}
          </div>

          <label>{t('WallOfLovePage.TypeEvent')}</label>
          <select value={eventType} onChange={(e) => setEventType(e.target.value)} required>
            <option value="" disabled>{t('WallOfLovePage.SelectEvent')}</option>
            {eventTypes.map((type, idx) => (
              <option key={idx} value={type}>{type}</option>
            ))}
          </select>

          <label>{t('WallOfLovePage.ExperienceMessage')}</label>
          <textarea
            value={description}
            onChange={(e) => {
              if (e.target.value.length <= 150) setDescription(e.target.value);
            }}
            placeholder={t('WallOfLovePage.ExperienceMessagee')}
            required
          />
          <div className="char-counter">{description.length}/150</div>

          <label>{t('WallOfLovePage.Email')} <span className="optional">{t('WallOfLovePage.Optional')}</span></label>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} />

          <ReCAPTCHA
            ref={recaptchaRef}
            size="invisible"
            sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
          />

          {errorMessage && (
            <div className="error-message-modal">
              {errorMessage}
            </div>
          )}

          {successMessage && (
            <div className="success-message-modal">
              {successMessage}
            </div>
          )}

          <button type="submit" className="submit-btn" disabled={loading}>
            {loading ? 'Sending...' : t('WallOfLovePage.Submit')}
          </button>

          <p className="recaptcha-legal">
            {t('WallOfLovePage.recaptcha_legal_start')}{' '}
            <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
              {t('WallOfLovePage.recaptcha_privacy')}
            </a>{' '}
            {t('WallOfLovePage.recaptcha_and')}{' '}
            <a href="https://policies.google.com/generalconditions" target="_blank" rel="noopener noreferrer">
              {t('WallOfLovePage.recaptcha_terms')}
            </a>{' '}
            {t('WallOfLovePage.recaptcha_end')}
          </p>
        </form>
      </div>
    </div>
  );
}

export default ReviewModal;
